import { Injectable } from '@angular/core';

@Injectable()
export class TextDecorationService {

    public toItalic(s: string) {

        if (!s) {
            return null;
        }

        let out = '';

        for (let c = 0; c < s.length; c++) {
            const code = s.charCodeAt(c);

            switch (true) {
                // Maiuscole non accentate
                case (code >= 65 && code <= 90):
                    out += String.fromCodePoint(code + 120328 - 65);
                    break;
                // Minuscole non accentate
                case (code >= 97 && code <= 122):
                    out += String.fromCodePoint(code + 120354 - 97);
                    break;
                // à
                case (code === 224):
                    out += '𝘢̀';
                    break;
                // è
                case (code === 232):
                    out += '𝘦̀';
                    break;
                // é
                case (code === 233):
                    out += '𝘦́';
                    break;
                // ì
                case (code === 236):
                    out += '𝘪̀';
                    break;
                // ò
                case (code === 242):
                    out += '𝘰̀';
                    break;
                // ù
                case (code === 249):
                    out += '𝘶̀';
                    break;
                default:
                    out += s[c];
            }
        }

        return out;
    }

    public toBold(s: string) {

        if (!s) {
            return null;
        }

        let out = '';

        for (let c = 0; c < s.length; c++) {
            const code = s.charCodeAt(c);

            switch (true) {
                // Maiuscole non accentate
                case (code >= 65 && code <= 90):
                    out += String.fromCodePoint(code + 120276 - 65);
                    break;
                // Minuscole non accentate
                case (code >= 97 && code <= 122):
                    out += String.fromCodePoint(code + 120302 - 97);
                    break;
                // à
                case (code === 224):
                    out += '𝗮̀';
                    break;
                // è
                case (code === 232):
                    out += '𝗲̀';
                    break;
                // é
                case (code === 233):
                    out += '𝗲́';
                    break;
                // ì
                case (code === 236):
                    out += '𝗶̀';
                    break;
                // ò
                case (code === 242):
                    out += '𝗼̀';
                    break;
                // ù
                case (code === 249):
                    out += '𝘂̀';
                    break;
                default:
                    out += s[c];
            }
        }

        return out;
    }
}
